import {Helpers} from "../../services/Helpers";
const Web3Utils = require('web3-utils');
// import IERC20 from "../../resources/IERC20.json";
import IYALLExchange from "../../resources/IYALLExchange.json";
import Web3Connection from "../../services/web3Connection";

let web3Contract;


export default {
    name: 'on-chain-tools',
    template: require('./OnChainTools.html'),
    data() {
        return {
            from: '',
            input: '',
            abi: '',
            abiString: '',
            abiNameToIndex: {},
            isAbiValid: false,
            zeroGetterResults: {},
            results: {},
            errors: {},
            inputs: {},
            address: '',
            link: '',
            getters: [],
            setters: []
        }
    },
    filters: {
        displaySimpleValue(val) {
        }
    },
    validations: {
        address: {
            isAddress(value) {
                return value === '' || Web3Utils.isAddress(value);
            }
        },
        from: {
            isAddress(value) {
                return value === '' || Web3Utils.isAddress(value);
            }
        }
    },
    async created() {
        // @ts-ignore
        // this.from = await Web3Connection.defaultAccount()
        await Web3Connection.connectToMetamask();
        const target = this.$parseQuery.get('target');

        if (target === 'contract-interface') {
            this.address = this.$parseQuery.get('contract-interface');
        }

        this.process();

        if (localStorage.latestContractFrom && localStorage.latestContractFrom.length > 0) {
            this.address = localStorage.latestContractFrom;
        }

        if (localStorage.latestContractAddress && localStorage.latestContractAddress.length > 0) {
            this.address = localStorage.latestContractAddress;
        }

        if (localStorage.latestContractAbi && localStorage.latestContractAbi.length > 0) {
            this.abiString = localStorage.latestContractAbi;
        }

        // load ABI
        this.parseAbi();
    },
    methods: {
        build() {
            if (Web3Utils.isAddress(this.address)) {
                localStorage.latestContractFrom = this.from;
                localStorage.latestContractAddress = this.address;
                this.parseAbi();
            }
        },
        process() {
        },
        updateInputValue(method, input, value) {
            this.inputs[`${method}-${input}`] = value;
        },
        async methodCall(name) {
            const values = this.getMethodValues(name);
            this.setMethodResult(name, 'Sending...')

            try {
                const res = await web3Contract.methods[name](...values).call();
                this.setMethodResult(name, JSON.stringify(res, null, 2))
            } catch (e) {
                this.setMethodError(name, e);
            }
        },
        async methodSend(name) {
            const values = this.getMethodValues(name);
            this.setMethodResult(name, 'Sending...')

            try {
                const res = await web3Contract.methods[name](...values).send({ from: this.from });
                this.setMethodResult(name, 'Sent')
            } catch (e) {
                this.setMethodError(name, e);
            }
        },
        async methodEstimateGas(name) {
            const values = this.getMethodValues(name);
            this.setMethodResult(name, 'Estimating gas...')

            try {
                const res = await web3Contract.methods[name](...values).estimateGas({ from: await Web3Connection.defaultAccount() });
                this.setMethodResult(name, `Estimated gas costs: ${res} gwei`)
            } catch (e) {
                this.setMethodError(name, e);
            }
        },
        async methodEncodeABI(name) {
            const values = this.getMethodValues(name);
            this.setMethodResult(name, 'Encoding...')

            try {
                const res = await web3Contract.methods[name](...values).encodeABI();
                this.setMethodResult(name, `Encoded calldata: ${res}`);
            } catch (e) {
                this.setMethodError(name, e);
            }
        },
        getMethodValues(name) {
            const inputs = this.abi[this.abiNameToIndex[name]].inputs;
            const values = inputs.map(i => this.inputs[`${name}-${i.name}`]);
            inputs.map(i => console.log('name', i.name));
            return values;
        },
        setMethodResult(name, resultMsg) {
            this.$set(this.results, name, resultMsg);
            this.$set(this.errors, name, '');
        },
        setMethodError(name, e) {
            if (e instanceof Error) {
                this.$set(this.errors, name, e.toString());
            } else {
                this.$set(this.errors, name, JSON.stringify(e, null, 2));
            }
            this.$set(this.results, name, '');
        },
        parseAbi() {
            this.abi = JSON.parse(this.abiString);
            localStorage.latestContractAbi = this.abiString;

            const web3 = Web3Connection.web3();
            web3Contract = new web3.eth.Contract(this.abi, this.address);

            this.abiNameToIndex = {};
            for (let i = 0; i < this.abi.length; i++) {
                this.abiNameToIndex[this.abi[i].name] = i;
            }

            this.getters = this.abi.filter(v => v.type === 'function' && (v.stateMutability == 'view' || v.stateMutability == 'pure'));
            this.setters = this.abi.filter(v => v.type === 'function' && !(v.stateMutability == 'view' || v.stateMutability == 'pure'));

            this.fetchZeroGetters();
        },
        async fetchZeroGetters() {
            const zeroGetters = this.getters.filter(v => v.inputs.length === 0).map(v => v.name);
            const calls = [];
            for (let i = 0; i < zeroGetters.length; i++) {
                calls.push(web3Contract.methods[zeroGetters[i]]().call());
            }

            const results = await Promise.all(calls);

            for (let i = 0; i < zeroGetters.length; i++) {
                const oneEther = 1000000000000000000;
                const outputs = this.abi[this.abiNameToIndex[zeroGetters[i]]].outputs;
                const isInt = outputs.length === 1 && outputs[0].internalType == 'uint256';
                let val = results[i];
                let parsedVal = parseInt(val, 10);

                if (isInt && parsedVal > oneEther) {
                    val = `${val} (${parsedVal / oneEther} ether)`;
                }

                this.$set(this.zeroGetterResults, zeroGetters[i], val);
            }
        },
        copyLink(e) {
            e.preventDefault();

            console.log('🔗', this.link);

            Helpers.copyToClipboard(this.link);
        }
    },
}
